import { render, staticRenderFns } from "./SwitchMgtView.vue?vue&type=template&id=79a2272a&scoped=true"
import script from "./SwitchMgtView.vue?vue&type=script&lang=js"
export * from "./SwitchMgtView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a2272a",
  null
  
)

export default component.exports